module.exports = __webpack_public_path__ + "media/Video 19.429da5bf.mp4";